import { Tooltip } from "antd";
import { FormattedMessage as IntlFormattedMessage, useIntl } from "react-intl";
import React, { Suspense } from "react";
import { INSTANCE_CONFIG } from "config/configHelpers";

const Markdown = React.lazy(() => import("components/markdown/Markdown"));


export type FormattedMessageProps = {
    id: string;
    defaultMessage: string;
    values?: Record<string, any>;
    markdown?: boolean;
    tooltipDisplay?: boolean;
    description?: string;
    optional?: boolean;
};

export default function FormattedMessage(props: FormattedMessageProps) {
    const debug = window?.debug?.translation;

    const intl = useIntl();

    if (props.optional && intl?.messages?.[props.id] === undefined) {
        return null;
    }

    const values = { ...props.values, brand: INSTANCE_CONFIG.companyName || "FastTony" }

    const text = intl.formatMessage(
        { id: props.id, defaultMessage: props.defaultMessage, description: props.description },
        values,
    );

    if (props.tooltipDisplay !== false && debug) {
        return (
            <Tooltip
                title={(
                    <div onClick={() => navigator.clipboard.writeText(props.id)}>
                        APP: {props.id}
                    </div>
                )}
            >
                <>
                    {props.markdown ? (
                        <Suspense fallback={null}>
                            <Markdown text={text} />
                        </Suspense>
                    ) : (
                        <IntlFormattedMessage {...props} values={values} />
                    )}
                </>
            </Tooltip>
        );
    }

    return props.markdown ? (
        <Suspense fallback={null}>
            <Markdown text={text} />
        </Suspense>
    ) : (
        <IntlFormattedMessage {...props} values={values} />
    );
}

export const TranslatedMessageWithKey = ({ message, messageId }: { message: string, messageId: string }) => {

    const debug = window?.debug?.translation;

    if (debug) {

        return (
            <Tooltip
                title={(<div
                    onClick={() => navigator.clipboard.writeText(messageId)}>
                    API: {messageId}
                </div>)}
            >
                <>
                    {message}
                </>
            </Tooltip>
        )
    }

    return (
        <>{message}</>
    )

}

export const FormattedCurrency = ({ value, currency }: { value: number, currency?: string }) => {

    const { formatNumber } = useIntl();

    if (!value) return null;

    return formatNumber(value, { style: 'currency', currency: currency ? currency : "PLN" });

}
